import { Box, Flex, Text } from '@applatform/design-system';

function LoginArt() {
  return (
    <Flex
      css={{
        position: 'relative',
        overflow: 'hidden',
        flexDirection: 'column',
        px: '$12',
        py: '$10',
        color: '$white',
        backgroundColor: '#242936',
      }}
    >
      <Box
        aria-hidden="true"
        css={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height: '62%',
          backgroundImage: 'linear-gradient(45deg, #6738BD 0%, #EE3932 100%)',
          maskImage: 'linear-gradient(to top, #000 0%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to top, #000 0%, transparent 100%)',
        }}
      />
      <Box css={{ position: 'relative', my: 'auto', maxWidth: '470px' }}>
        <Text
          css={{
            fontSize: '40px',
            lineHeight: 1.1,
            m: 0,
            mb: '$3',
            letterSpacing: '-0.035em',
            fontWeight: '$bold',
            color: 'inherit',
          }}
        >
          Move money for your platform, and see every cent of it.
        </Text>
        <Text
          css={{
            fontSize: '15px',
            lineHeight: 1.55,
            m: 0,
            color: 'rgba(255,255,255,.78)',
          }}
        >
          Payins, payouts, wallets and settlements for Australian marketplaces —
          in one console your ops team can actually work from.
        </Text>
      </Box>
      <Text
        css={{
          position: 'relative',
          mt: 'auto',
          fontSize: '12px',
          color: '$white',
        }}
      >
        &copy; {new Date().getFullYear()} Zai
      </Text>
    </Flex>
  );
}

export default LoginArt;
